/** Label for the colleague chat action (Teams vs portal). */
export function intranetChatActionLabel(reachesViaTeams: boolean): string {
  return reachesViaTeams ? 'In Teams schreiben' : 'Nachricht schreiben';
}

export const INTRANET_CHAT_PROFILE_UNAVAILABLE = 'Dieses Profil ist nicht verfügbar.';
